import(/* webpackMode: "eager" */ "/home/osborne/OSBORNE_FRONT_STAGE_3/app/[locale]/template.tsx");
